import { useEffect } from 'react';

import { dataLayerHandleEvent } from 'utils/dataLayers';

import GenericCampaing from './generic';

function CustomLanding({ campaign, tnmProps }) {
  useEffect(() => {
    const eventGA4 = {
      event: 'acquisition_landing',
      info_type: 'impression',
      campaign_detail: campaign?.name?.toLowerCase() || '',
      page_type: 'landing',
    };
    dataLayerHandleEvent(eventGA4);
  }, []);

  return (
    <GenericCampaing campaign={campaign} tnmProps={tnmProps} />
  );
}

export default CustomLanding;
